import { render, staticRenderFns } from "./AboutEstar.vue?vue&type=template&id=4cbd8cfc&scoped=true"
import script from "./AboutEstar.vue?vue&type=script&lang=js"
export * from "./AboutEstar.vue?vue&type=script&lang=js"
import style0 from "./AboutEstar.vue?vue&type=style&index=0&id=4cbd8cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd8cfc",
  null
  
)

export default component.exports